//#region src/schema/localization/locales/fr.ts
var e = {
	schema: {
		variants: "Variantes",
		discriminatorValue: "Valeur du discriminateur",
		noAllowedValues: "Aucune valeur ne satisfait cette contrainte enum.",
		example: "Exemple",
		examples: "Exemples",
		default: "Par défaut",
		schema: "Schéma",
		emptyObject: "Objet vide",
		showAdditionalProperties: "Afficher les propriétés supplémentaires",
		showOneMoreProperty: "Afficher 1 propriété supplémentaire",
		showMoreProperties: "Afficher {count} propriétés supplémentaires",
		forName: "pour {name}",
		showSchemaDetails: "Afficher les détails du schéma",
		oneOf: "Un parmi",
		anyOf: "N’importe lequel parmi",
		allOf: "Tous parmi",
		not: "Non",
		unknownType: "type inconnu",
		propertyCount: "Propriétés : {count}",
		headerCount: "En-têtes : {count}",
		recursiveReference: "Référence récursive vers {name}",
		recursive: "récursif",
		additionalProperties: "propriétés supplémentaires",
		const: "constante",
		deprecated: "obsolète",
		discriminator: "Discriminateur",
		enum: "enum",
		format: "Format",
		greaterThan: "supérieur à",
		keys: "clés",
		lessThan: "inférieur à",
		max: "max.",
		min: "min.",
		maxLength: "longueur max.",
		minLength: "longueur min.",
		multipleOf: "multiple de",
		nullable: "nullable",
		propertyNames: "noms des propriétés",
		pattern: "Motif",
		copyPattern: "Copier le motif",
		readOnly: "lecture seule",
		required: "obligatoire",
		hideValues: "Masquer les valeurs",
		showAllValues: "Afficher toutes les valeurs",
		type: "Type",
		unique: "unique",
		values: "valeurs",
		writeOnly: "écriture seule",
		typeInteger: "Nombres entiers.",
		formatInt32: "Entiers signés sur 32 bits (type entier courant).",
		formatInt64: "Entiers signés sur 64 bits (type long).",
		formatDate: "notation full-date définie par la RFC 3339, section 5.6, par exemple 2017-07-21",
		formatDateTime: "notation date-time définie par la RFC 3339, section 5.6, par exemple 2017-07-21T17:32:28Z",
		formatPassword: "indique aux interfaces de masquer la saisie",
		formatBase64: "caractères encodés en base64, par exemple U3dhZ2dlciByb2Nrcw==",
		formatBinary: "données binaires, utilisées pour décrire des fichiers"
	},
	common: {
		copyDefault: "Copier la valeur par défaut",
		copyExample: "Copier la valeur d’exemple"
	},
	actions: { copyLinkTo: "Copier le lien vers {name}" }
};
//#endregion
export { e as fr };

//# sourceMappingURL=fr.js.map